import { GridFilterItem } from '@rossum/ui/x-data-grid-pro';
import { FilterOperator } from '../mql/operators';

export type ValueOptions = { label: string; value: string; count?: number }[];

export type FilterColDef = {
  operators: FilterOperator[];
  areValuesLoading?: boolean;
  disableWithNoValues?: boolean;
  valueOptions?: ValueOptions;
  allowedMultipleOperatorInstances?: Array<FilterOperator['value']>;

  // These three properties intersect with GridColDef properties
  // That is ok, you need field to construct both filter and grid
  headerName?: string;
  field: string;
  dataType?: string;
};

export type ValidatedGridFilterItem = GridFilterItem & { isValid: boolean };

export type FilterValues = {
  operator: FilterOperator;
  value?: unknown;
};
export type FilterContext = FilterValues | FilterValues[];

export type FilterItem = {
  column: FilterColDef;
  filterContext: FilterContext;
};

export type ValidatedFilterItem = FilterItem & { isValid: boolean };
// "simple components" is the name we give to components that are only rendered when the filter is simple (filter context is not an array)
// SimpleFilterItem is the type we use to tell "simple components" that filterContext is not an array so as to simplify the code that goes on in them

export type SimpleFilterItem = Omit<FilterItem, 'filterContext'> & {
  filterContext: FilterValues;
};

export type AdvancedFilterItem = Omit<FilterItem, 'filterContext'> & {
  filterContext: FilterValues[];
};
export const isFilterAdvanced = (
  filterItem: FilterItem
): filterItem is AdvancedFilterItem => Array.isArray(filterItem.filterContext);

export const isFilterSimple = (
  filterItem: FilterItem
): filterItem is SimpleFilterItem => !Array.isArray(filterItem.filterContext);

export const isFilterContextSimple = (
  filterContext: FilterContext
): filterContext is FilterValues => !Array.isArray(filterContext);
